var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-2 border"},[_c('small',[_c('pre',[_vm._v(_vm._s(_vm.label)),_c('br'),_vm._v(_vm._s(_vm.info))])]),_c('div',{ref:"sensorcanvas",attrs:{"id":"sensorcanvas"}},[_c('canvas',{ref:"canvassensor"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }